import { API_ENDPOINTS } from '../constants/api-endpoints';
import { API } from './api-config';

const { JOB } = API_ENDPOINTS;
const { CURRENT_POSITION, POSITION_HISTORY } = JOB;

export const ApiJob = {
  currentPosition: (pinfl: string | number) => {
    return API({
      path: CURRENT_POSITION,
      method: 'GET',
      pathParams: { pinfl },
    });
  },

  positionHistory: (pinfl: string | number) => {
    return API({
      path: POSITION_HISTORY,
      method: 'GET',
      pathParams: { pinfl },
    });
  },
};
